import { isCommonLocale } from "@/src/utils/helpers";

import { Locale } from "../../../types";
import formatNumberToLocale, {
  localeToIntlLocale,
} from "./formatNumberToLocale";

/**
 * 지정된 로케일의 형식 규칙에 따라 숫자를 포맷팅합니다.
 *
 * @param number - 포맷팅할 숫자
 * @param locale - 포맷팅에 사용할 로케일 (예: 'en', 'fr', 'ko')
 * @param minimumFractionDigits - 소수점 이하 자릿수의 최소값을 지정하는 선택적 매개변수
 * @returns 숫자의 포맷팅된 문자열 표현
 */
export function formatPointNumber(
  number: number | bigint,
  locale: Locale,
  minimumFractionDigits?: number
) {
  if (isCommonLocale(locale)) {
    return formatNumberToLocale(
      number,
      // eslint-disable-next-line security/detect-object-injection -- locale은 Locale union 타입, 리터럴 Record 읽기 전용 접근
      localeToIntlLocale[locale],
      minimumFractionDigits
    );
  }
  // 다른 로케일의 경우 기본 포맷을 사용할 수 있습니다.
  return number.toString();
}
